import BaseComponent from "../../../baseComponent.js";
import GlobeComponent from "./globe.jsx";
import csv2array from "csv2array";
import InternalEvent from "../../../../core/constants/internalEvent.js";

export default class EarthQuakeGlobe extends BaseComponent {
  constructor(props) {
    super(props);
    $.ajax({
      url: "/resources/globe/earthquakes-2015.csv",
      asyc: false,
      success: (csvd) => {
        this.earthquakeData = csv2array(csvd, {separator: ";"});
        setTimeout(() => {
          this.globeBody = <div id="globe-body">
            <GlobeComponent earthquakeData={this.earthquakeData}/>
          </div>;
          this.forceUpdate();
        }, 1);
      },
      dataType: 'text'
    });
  }

  componentDidUpdate() {
    $('#globe-body').css('opacity', '0');
    $('#globe-body').css('display', 'none').css('opacity', '1').fadeIn({duration: 600});
    this.publish(InternalEvent.App.HIDE_PRELOADER);
  }

  render() {
    return (
      <div>
        {this.globeBody}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/globe/earthquakes/globe-widget.jsx